<script lang="ts">
    import { onMount } from 'svelte'

    import Banner from './Banner.svelte'
    import { consent, status } from './consent'
    import { cookieIcon } from './icons'
    import Icon from './Icon.svelte'

    let showing: null | 'banner' | 'closed' | 'modal' = $state(null)

    onMount(() => {
        consent.setup()
    })

    $effect(() => {
        if ($status == 'ok') {
            showing = 'closed'
        } else if ($status == 'new') {
            showing = 'banner'
        }
    })
</script>

{#if showing}
    <div id="consent" class="mode-{showing}" aria-modal={showing == 'modal'} aria-describedby={showing == 'modal' || showing == 'banner' ? 'conb-desc' : null} role={showing == 'modal' ? 'dialog' : null}>
        {#if showing == 'closed'}
            <button
                type="button"
                onclick={() => {
                    showing = 'modal'
                }}><Icon icon={cookieIcon} /></button
            >
        {:else if showing == 'banner' || showing == 'modal'}
            <Banner
                mode={showing}
                close={() => {
                    showing = $status == 'new' ? 'banner' : 'closed'
                }}
                toModal={() => {
                    showing = 'modal'
                }}
                saved={() => {
                    showing = 'closed'
                }}
            />
        {/if}
    </div>
{/if}
{#if showing == 'modal'}
    <div id="conb-backdrop"></div>
{/if}
